import { IImage, ISiteSettings } from '@topshots/core-models';
import { topshotsAPI } from '../../app/api';
// import { Image } from '../images/images.types';

const settingsApi = topshotsAPI.injectEndpoints({
  endpoints: (build) => ({
    setWatermark: build.mutation<IImage, { image: File }>({
      query: (request) => {
        const data = new FormData();
        data.append('file', request.image);
        return {
          url: `sitesettings/watermark`,
          method: 'POST',
          body: data,
        };
      },
      invalidatesTags: (result, error, product) => [{ type: 'Watermark' }],
    }),
    getWatermark: build.query<IImage, void>({
      query: () => ({
        url: `sitesettings/watermark`,
        method: 'GET',
      }),
      providesTags: (result, error, page) => [
        { type: 'Watermark' as const, id: 'Watermark' },
      ],
    }),
    deleteWatermark: build.mutation<void, void>({
      query: () => ({
        url: `sitesettings/watermark`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, product) => [{ type: 'Watermark' }],
    }),
    setLogo: build.mutation<ISiteSettings, { image: File }>({
      query: (request) => {
        const data = new FormData();
        data.append('file', request.image);
        return {
          url: `sitesettings/logo`,
          method: 'POST',
          body: data,
        };
      },
      invalidatesTags: () => ['SiteSettings'],
    }),
    deleteLogo: build.mutation<void, void>({
      query: () => ({
        url: `sitesettings/logo`,
        method: 'DELETE',
      }),
      invalidatesTags: () => ['SiteSettings'],
    }),
    setLogoLight: build.mutation<ISiteSettings, { image: File }>({
      query: (request) => {
        const data = new FormData();
        data.append('file', request.image);
        return {
          url: `sitesettings/logo-light`,
          method: 'POST',
          body: data,
        };
      },
      invalidatesTags: () => ['SiteSettings'],
    }),
    deleteLogoLight: build.mutation<void, void>({
      query: () => ({
        url: `sitesettings/logo-light`,
        method: 'DELETE',
      }),
      invalidatesTags: () => ['SiteSettings'],
    }),
    getSettings: build.query<ISiteSettings, void>({
      query: (request) => ({
        url: `sitesettings`,
        method: 'GET',
      }),
      providesTags: (result, error, product) => ['SiteSettings'],
    }),
    updateSettings: build.mutation<
      ISiteSettings,
      { data: Partial<ISiteSettings> }
    >({
      query: (request) => ({
        url: `sitesettings`,
        method: 'PUT',
        body: request.data,
      }),
      invalidatesTags: (result, error, product) => ['SiteSettings'],
    }),
  }),
});

export const {
  useDeleteWatermarkMutation,
  useSetWatermarkMutation,
  useGetWatermarkQuery,
  useGetSettingsQuery,
  useUpdateSettingsMutation,
  useSetLogoMutation,
  useDeleteLogoMutation,
  useSetLogoLightMutation,
  useDeleteLogoLightMutation,
} = settingsApi;
